import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.5rem"} }, "Отмена", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.688rem"} }, "Продолжить", -1)

import { ref } from "vue";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from "tir-components";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-pm-comment-dialog-modal',
  setup(__props, { expose: __expose }) {

const isVisible = ref(false);

let callback: (confirm: boolean) => void | undefined = undefined;

/**Открыть модальное окно */
const open = async () => {
  return new Promise<boolean>((resolve) => {
    callback = (confirm) => {
      resolve(confirm);
    };
    isVisible.value = true;
  });
};
/**Закрыть модальное окно */
const close = () => {
  callback = undefined;
  isVisible.value = false;
};

/**При выходе */
const cancel = () => {
  callback?.(false);
  close();
};

/**При отмене выхода */
const confirm = () => {
  callback?.(true);
  close();
};

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    "is-visible": isVisible.value,
    title: "Внимание: комментарий не отправлен",
    "is-with-back": false,
    onClose: cancel
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: cancel
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        onClick: confirm
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _: 1
  }, 8, ["is-visible"]))
}
}

})